// extracted by mini-css-extract-plugin
export default {"root":"BadgeCard_root__NOyim"};